import { Box, LinearProgress } from "@mui/material";

export default function Loading() {
    return (
        <Box mt="-4px">
            <LinearProgress />
        </Box>
    );

}